import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  connect() {
    this.pageHeight = 900
    this.availableSpace = this.pageHeight
    this.insertPageBreaks()
  }

  insertPageBreaks() {
    this.imageTargets.forEach((image, index) => {
      const imageHeight = image.clientHeight

      if (this.availableSpace < imageHeight) {
        this.insertPageBreakBefore(image)
        this.availableSpace = this.pageHeight
      }

      this.availableSpace -= imageHeight

      if (index === this.imageTargets.length - 1 && this.availableSpace < 0) {
        this.insertPageBreakAfter(image)
      }
    })
  }

  insertPageBreakBefore(element) {
    const pageBreakDiv = document.createElement("div")
    pageBreakDiv.className = "page-break"
    pageBreakDiv.style.pageBreakBefore = "always"
    element.parentNode.insertBefore(pageBreakDiv, element)
  }

  insertPageBreakAfter(element) {
    const pageBreakDiv = document.createElement("div")
    pageBreakDiv.className = "page-break"
    pageBreakDiv.style.pageBreakAfter = "always"
    element.parentNode.insertBefore(pageBreakDiv, element.nextSibling)
  }
}
